import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {FormsModule} from '@angular/forms'
import {UISharedModule} from '../ui-shared/ui-shared.module'
import {UserRoutingModule} from './user-routing.module'
import {UserLoginComponent} from './user-login/user-login.component'
import {UserEditComponent} from './user-edit/user-edit.component'
import {UserViewComponent} from './user-view/user-view.component'

@NgModule({
  imports: [CommonModule, FormsModule, UISharedModule, UserRoutingModule],
  declarations: [UserLoginComponent, UserEditComponent, UserViewComponent],
  providers: [],
})
export class UserModule {}



// WEBPACK FOOTER //
// /Users/axel/Sites/Bannerboy/Internal/attaboy-angular/src/app/user/user.module.ts